(() => {
	const badgeSelector = '.product-info__block .jdgm-preview-badge';
	const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

	const findTarget = () => {
		const own = document.querySelector('[data-nd-product-reviews]');
		if (own) return own;
		const carousel = document.querySelector('.jdgm-cards-carousel');
		return carousel ? carousel.closest('.shopify-section') || carousel : null;
	};

	const totals = () => {
		const node = document.querySelector('[data-nd-review-totals]');
		if (!node) return null;
		const count = parseInt(node.getAttribute('data-nd-count'), 10);
		const average = parseFloat(node.getAttribute('data-nd-average'));
		return count > 0 && !Number.isNaN(average) ? { count, average } : null;
	};

	const restar = (badge, average) => {
		const stars = badge.querySelector('.jdgm-prev-badge__stars');
		if (!stars) return;
		stars.setAttribute('data-score', String(average));
		stars.setAttribute('aria-label', `${average} stars`);
		stars.querySelectorAll('.jdgm-star').forEach((star, index) => {
			const left = average - index;
			star.classList.remove('jdgm--on', 'jdgm--half', 'jdgm--off');
			star.classList.add(left >= 0.75 ? 'jdgm--on' : left >= 0.25 ? 'jdgm--half' : 'jdgm--off');
		});
	};

	const format = (badge) => {
		const data = badge.querySelector('.jdgm-prev-badge');
		const text = badge.querySelector('.jdgm-prev-badge__text');
		if (!data || !text) return;
		const store = totals();
		const count = store ? store.count : parseInt(data.getAttribute('data-number-of-reviews'), 10);
		const raw = store ? store.average : parseFloat(data.getAttribute('data-average-rating'));
		if (!(count > 0) || Number.isNaN(raw)) return;
		const average = Math.floor(raw * 10) / 10;
		const label = `${average.toFixed(1)} (${count} ${count === 1 ? 'review' : 'reviews'})`;
		if (text.textContent !== label) text.textContent = label;
		if (!store) return;
		restar(badge, average);
		data.setAttribute('data-average-rating', average.toFixed(2));
		data.setAttribute('data-number-of-reviews', String(count));
		[badge, data].forEach((node) => {
			if (getComputedStyle(node).display === 'none') node.style.setProperty('display', 'block', 'important');
		});
	};

	const enable = (badge) => {
		if (badge.hasAttribute('data-nd-reviews-link') || !findTarget()) return;
		badge.setAttribute('data-nd-reviews-link', '');
		badge.setAttribute('role', 'link');
		badge.setAttribute('tabindex', '0');
	};

	const refresh = () => {
		document.querySelectorAll(badgeSelector).forEach((badge) => {
			format(badge);
			enable(badge);
		});
	};

	const scrollToReviews = () => {
		const target = findTarget();
		if (!target) return;
		const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--glob-header-height')) || 0;
		if (window.lenis && typeof window.lenis.scrollTo === 'function') {
			window.lenis.scrollTo(target, { offset: -header, immediate: motion.matches });
		} else {
			window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - header, behavior: motion.matches ? 'auto' : 'smooth' });
		}
		target.setAttribute('data-nd-reviews-target', '');
		target.setAttribute('tabindex', '-1');
		target.focus({ preventScroll: true });
	};

	const linkedBadge = (event) => {
		const badge = event.target instanceof Element ? event.target.closest(badgeSelector) : null;
		return badge && badge.hasAttribute('data-nd-reviews-link') ? badge : null;
	};

	const take = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
		scrollToReviews();
	};

	document.addEventListener('click', (event) => {
		if (!linkedBadge(event)) return;
		take(event);
	}, true);

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter' || !linkedBadge(event)) return;
		take(event);
	}, true);

	refresh();
	new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
})();
